import { render, staticRenderFns } from "./jenisatap.vue?vue&type=template&id=56ddf2f6"
import script from "./jenisatap.vue?vue&type=script&lang=js"
export * from "./jenisatap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports